// removed by extract-text-webpack-plugin
module.exports = {"react-django-template":"PassengerListFlight__react-django-template___-hash--base64-5-"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/AirlineSeatSelection/PassengerListFlight.scss
 ** module id = 875
 ** module chunks = 1
 **/